import { PopUpName } from '../core/managers/PopUpManager';
import { AbstractPopUp, AbstractPopUpParams } from './AbstractPopUp';
import { createSprite, translate } from '../utils/GameEngine';
import { degToRad } from '../utils/MathUtils';
import { TextStyles } from '../utils/TextStyles';
import { clearAnimations } from '../utils/Animations';

export class LoadingPopUp extends AbstractPopUp {
    private loadingIcon: PIXI.Sprite;

    constructor(public readonly name: PopUpName, public params: AbstractPopUpParams) {
        super(name, params);
    }

    protected drawLayout(): void {
        super.drawLayout();
        this.background.cacheAsBitmap = false;
        this.bgSprite.alpha = 0.7;
        this.bgSprite.interactive = true;
        this.background.cacheAsBitmap = true;
        this.loadingIcon = createSprite('loading_donut', this);
        this.loadingIcon.anchor.set(0.5, 0.5);
        this.loadingIcon.scale.set(2, 2);
        this.loadingIcon.position.set(this.width / 2 - this.loadingIcon.width / 2, this.height / 2);
        const loadingText: PIXI.Text = new PIXI.Text(translate('Loading') + '...', TextStyles.messageText);
        this.addChild(loadingText);
        loadingText.anchor.set(0.5, 0.5);
        loadingText.position.set(this.loadingIcon.x, this.loadingIcon.y - 150);

        const text1: string = FBInstant.player.getName() + ', ' + translate('by watching an ad,\nyou support us in creating more free content' + '!');
        const text2: string = translate('We would like to say:\nThank you') + ', ' + FBInstant.player.getName() + '!';
        let tyText: string;
        if (Math.random() < 0.5) {
            tyText = text1;
        } else {
            tyText = text2;
        }
        const thankYouText: PIXI.Text = new PIXI.Text(tyText, TextStyles.smallMessageText);
        this.addChild(thankYouText);
        thankYouText.anchor.set(0.5, 0.5);
        thankYouText.position.set(this.loadingIcon.x, this.loadingIcon.y + 150);
    }

    private playAnimation(): void {
        TweenMax.to(this.loadingIcon, 1, {
            rotation: degToRad(720),
            repeat: -1
        });
    }

    private stopAnimation(): void {
        clearAnimations(this.loadingIcon);
        this.loadingIcon.rotation = 0;
    }

    public show(quick: boolean = false): void {
        this.playAnimation();
        super.show(quick);
    }

    public hide(quick: boolean = false): void {
        this.stopAnimation();
        super.hide(quick);
    }
}